import React, { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import { func, bool, array } from 'prop-types';
import classnames from 'classnames';
import { Modal, Row, Col, Button, Input } from 'grab-ui';
import _get from 'lodash/get';
import {
  CANCEL_REASON_I18N_MAP,
  ID_OTHER_REASON,
  DEFAULT_RATING,
} from 'constants/app-constants';
import { cancelReasonsSelector } from 'selectors/history-selector';
import { fetchCancelReasonsAction } from 'actions/history-actions';
import css from './feedback-modal.less';

const TextArea = Input.TextArea;

const EMPTY_FEEDBACK = {
  clickedFeedback: {
    id: '',
    content: '',
  },
  comment: '',
};

export class RawFeedbackModal extends Component {
  static propTypes = {
    visible: bool,
    dispatch: func.isRequired,
    handleSubmit: func.isRequired,
    cancelReasons: array, //eslint-disable-line
  };

  static defaultProps = {
    visible: false,
    cancelReasons: undefined,
  };

  constructor(props) {
    super(props);
    this.state = EMPTY_FEEDBACK;
  }

  componentDidMount() {
    const { dispatch, cancelReasons } = this.props;
    if (!cancelReasons) {
      dispatch(fetchCancelReasonsAction());
    }
  }

  onTypingComment = ({ target: { value: comment } }) => {
    this.setState({ comment });
  };

  handleSelectOptions = (feedbackId, response) => () => {
    this.setState({
      clickedFeedback: {
        id: feedbackId,
        content: response,
      },
    });
  };

  collectFormValues = () => {
    const { clickedFeedback, comment } = this.state;
    const mcqReason =
      comment.length !== 0 && clickedFeedback.id !== ID_OTHER_REASON
        ? [clickedFeedback.id, ID_OTHER_REASON]
        : [clickedFeedback.id];
    this.setState(EMPTY_FEEDBACK);
    return {
      feedback: {
        comment: comment.length === 0 ? clickedFeedback.content : comment,
        mcqReason,
        rating: DEFAULT_RATING,
      },
    };
  };

  handleSubmitFeedBack = () => {
    const { handleSubmit } = this.props;
    const formValues = this.collectFormValues();
    handleSubmit(formValues);
  };

  render() {
    const { visible, cancelReasons } = this.props;
    const { clickedFeedback } = this.state;
    return (
      <div>
        <Modal
          centered
          closable={false}
          visible={visible}
          style={{ top: 100 }}
          className={css.feedbackModal}
          footer={[
            <Button
              disabled={!clickedFeedback.id}
              type="primary"
              key="submit"
              onClick={this.handleSubmitFeedBack}
            >
              {I18n.t('v2.commonButton.submit')}
            </Button>,
          ]}
        >
          <Row>
            <p className={css.heading}>
              {I18n.t('history.feedbackItems.title')}
            </p>
          </Row>
          <div className={css.wrappedContainer}>
            {cancelReasons && cancelReasons.length > 0
              ? cancelReasons.map(cancelReason => (
                  <Row
                    onClick={this.handleSelectOptions(
                      cancelReason.id,
                      cancelReason.response,
                    )}
                    className={classnames(css.container, {
                      [`${css.hightlightOption}`]:
                        cancelReason.id === clickedFeedback.id,
                    })}
                    key={cancelReason.id}
                    type="flex"
                  >
                    <Col className={css.wrappedIcon} span={2}>
                      <img
                        className={css.tralvelOptionIcon}
                        src={cancelReason.icon}
                        alt="Grab"
                      />
                    </Col>
                    <Col offset={1} span={21}>
                      <p>
                        {cancelReason.response ||
                          I18n.t(
                            _get(
                              CANCEL_REASON_I18N_MAP,
                              cancelReason.id,
                              'history.feedbackItems.empty',
                            ),
                          )}
                      </p>
                    </Col>
                  </Row>
                ))
              : null}
            <Row>
              <Col className={css.container} span={20}>
                <TextArea
                  placeholder={I18n.t('history.feedbackItems.shareThought')}
                  onChange={this.onTypingComment}
                />
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(state => ({
  cancelReasons: cancelReasonsSelector(state),
}))(RawFeedbackModal);
